export default "僞 偽|啓 啟|喫 吃|嫺 嫻|嬀 媯|峯 峰|幺 么|棱 稜|樑 梁|檐 簷|污 汙|泄 洩|潙 溈|潨 潀|爲 為|牀 床|痹 痺|癡 痴|皁 皂|着 著|睾 睪|祕 秘|竈 灶|糉 粽|繮 韁|纔 才|羣 群|脣 唇|蔘 參|蔿 蒍|衆 眾|裏 裡|覈 核|踊 踴|鉢 缽|鍼 針|鮎 鯰|麪 麵|齶 顎";
//# sourceMappingURL=TWVariants.js.map